import * as Types from '../gql/types2';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {"context":{"clientName":"graphql2"}} as const;
export type SplitChargeMutationVariables = Types.Exact<{
  input: Types.SplitChargeCommand;
}>;


export type SplitChargeMutation = { __typename?: 'MutationModel', projectCharges: { __typename?: 'ProjectChargesMutationModel', splitCharge: { __typename?: 'SplitChargeResponse', splitChargeIds: Array<number>, errors: Array<{ __typename?: 'ValidationError', argumentName?: string | null, message: string }> } } };


export const SplitChargeDocument = gql`
    mutation SplitCharge($input: SplitChargeCommand!) {
  projectCharges {
    splitCharge(input: $input) {
      errors {
        argumentName
        message
      }
      splitChargeIds
    }
  }
}
    `;
export type SplitChargeMutationFn = Apollo.MutationFunction<SplitChargeMutation, SplitChargeMutationVariables>;

/**
 * __useSplitChargeMutation__
 *
 * To run a mutation, you first call `useSplitChargeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSplitChargeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [splitChargeMutation, { data, loading, error }] = useSplitChargeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSplitChargeMutation(baseOptions?: Apollo.MutationHookOptions<SplitChargeMutation, SplitChargeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SplitChargeMutation, SplitChargeMutationVariables>(SplitChargeDocument, options);
      }
export type SplitChargeMutationHookResult = ReturnType<typeof useSplitChargeMutation>;
export type SplitChargeMutationResult = Apollo.MutationResult<SplitChargeMutation>;
export type SplitChargeMutationOptions = Apollo.BaseMutationOptions<SplitChargeMutation, SplitChargeMutationVariables>;